import axios from "axios"

const BASE_URL = "https://validatemint.idexo.io"

const config = {
    headers: {
        "Content-Type": "application/json",
        token: localStorage.jwtToken
    }
}

export const api = {
    getNft: async (walletAddress) => {
        const body = {
            type: "get_nft",
            walletAddress: walletAddress
        }
        try {
            let response = await axios.post(BASE_URL, body, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    },

    getPending: async (walletAddress) => {
        const body = {
            type: "get_pending",
            walletAddress: walletAddress
        }
        try {
            let response = await axios.post(BASE_URL, body, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    },
    changePending: async (walletAddress) => {
        const body = {
            type: "accepted",
            walletAddress: walletAddress
        }
        try {
            let response = await axios.post(BASE_URL, body, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    }
}
